<template>
    <div>
        <div v-if="getSaleItemList.length>0">
        <span><b>Copy this work-order and paste them into the below order items:</b></span>
        <br><br>
        
        <div style="display: flex; flex-direction: column; margin-bottom: 10px;"
            v-for="(data, index) in getSaleItemList" 
            :key="index">
            <div style="display: flex; flex-direction: column;" v-if="data.sale_item_id > 0">
                
                <el-checkbox @change="selectData(data)" :checked="data.selected">
                    <span style="margin-left: 10px;">
                        {{data.sl_no+1}}. {{data.tailoring_detail !== undefined ? data.tailoring_detail.template_name : data.template_name}}                            
                    </span>
                    <span v-if="!data.single_item && data.work_order_id === 0" style="color: red; font-size: 10px;">
                    Please copy the other item from this work-order group to avoid ERROR
                </span>
                </el-checkbox>                    
            </div>
        </div>
  </div>
  <div v-else>
    <span><b>No Items To Copy!!!</b></span>
  </div>
    </div>
  
</template>

<script>
export default {
    props: ['workOrderData', 'sale_item_index'],
    computed: {
        getSaleItemList() {
            return this.workOrderData.copy_items
        },
        getItemList() {
            return [] 
        }
    },
    methods: {
        selectData(data) {
            data.selected = !data.selected
        }
    },
    mounted() {
        this.workOrderData.copy_items = []
        if(this.$store.getters.getWorkOrderDataProps.length > 1) {
            this.$store.getters.getWorkOrderDataProps.filter(t => t.tailoring_item_id === this.workOrderData.tailoring_item_id).forEach(el => {
                let singleItem = JSON.parse(JSON.stringify(this.$store.getters.getSaleMasterDataProps.item_list.filter(t => t.sl_no !== this.sale_item_index && t.tailoring_item_id  === el.tailoring_item_id)))
                if(singleItem.length > 0) {
                    singleItem.forEach(item => {
                        item.selected = false
                        item.sale_item_id = item.id
                        item.sale_sub_item_id = 0
                        item.single_item = true
                        this.workOrderData.copy_items.push(item)
                    })
                }

                let subItemList = this.$store.getters.getSaleMasterDataProps.item_list
                    .filter(t => t.sl_no !== this.sale_item_index && t.tailoring_detail.is_combination_item === 1)
                    
                if(subItemList.length > 0) {
                    subItemList.forEach(mainItem => {
                        let combination_item_list = JSON.parse(JSON.stringify(mainItem.combination_item_list.filter(t => t.tailoring_item_id  === el.tailoring_item_id)))
                        combination_item_list.forEach(item => {
                            item.selected = false
                            item.sl_no = mainItem.sl_no
                            item.sale_item_id = mainItem.id
                            item.sale_sub_item_id = item.id
                            item.single_item = false
                            this.workOrderData.copy_items.push(item)
                        })  
                    })
                }

                
            })

        } else {
            let copyItems = JSON.parse(JSON.stringify(this.$store.getters.getSaleMasterDataProps.item_list
            .filter(t => t.sl_no !== this.sale_item_index && t.tailoring_item_id  === this.workOrderData.tailoring_item_id)))
            copyItems.forEach(item => {
                item.selected = false
                item.sale_item_id = item.id
                item.sale_sub_item_id = 0
                item.single_item = true
                this.workOrderData.copy_items.push(item)
            })  
        }
        
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/WorkOrder/CopyItems.vue